export default __webpack_public_path__ + "static/media/error-image.f5b9beb0.svg";